import { clearToken, getToken, refreshSession } from "./auth";
import { API_BASE } from "./apiBase";
import { getApiErrorMessage } from "./errorMessages";

export async function apiFetch(path, options = {}, canRetry = true) {
  const headers = new Headers(options.headers || {});
  headers.set("Content-Type", "application/json");
  const token = getToken();
  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
    credentials: "include",
  });

  if (response.status === 401 || response.status === 403) {
    if (canRetry) {
      const refreshed = await refreshSession();
      if (refreshed) {
        return apiFetch(path, options, false);
      }
    }
    clearToken();
    if (response.status === 401) {
      window.dispatchEvent(new CustomEvent("session-expired"));
    }
  }

  if (!response.ok) {
    const message = await safeErrorMessage(response);
    throw new Error(message || "Error inesperado en la API.");
  }

  if (response.status === 204) {
    return null;
  }
  const text = await response.text();
  if (!text) {
    return null;
  }
  return JSON.parse(text);
}

export function fetchSummary() {
  return apiFetch("/api/v1/bitpanda/transactions/summary");
}

export function fetchBalance() {
  return apiFetch("/api/v1/portfolio/balance");
}

export function fetchBalanceAsset(symbol) {
  return apiFetch(`/api/v1/bitpanda/balance/${encodeURIComponent(symbol)}`);
}

export function fetchAssets() {
  return apiFetch("/api/v1/bitpanda/assets");
}

export function fetchAssetTransactions(symbol) {
  return apiFetch(`/api/v1/bitpanda/assets/${encodeURIComponent(symbol)}/transactions`);
}

async function safeErrorMessage(response) {
  try {
    const data = await response.json();
    return getApiErrorMessage(data, response.status);
  } catch (_) {
    return null;
  }
}
